import {
  type RollPositionDialogProps,
  useRollPositionDialogController,
} from "./RollPositionDialog.controller";
import { RollPositionDialogPresentation } from "./RollPositionDialog.pres";

export type { RollPositionDialogProps };

export const RollPositionDialog = (props: RollPositionDialogProps) => {
  const controller = useRollPositionDialogController(props);
  return <RollPositionDialogPresentation {...controller} />;
};
